module.exports = __webpack_public_path__ + "img/examine.7d4c3f79.png";